import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_APPROVER } from '../../../actions/types';
import {Icon} from '@fluentui/react';
import PropTypes from 'prop-types';
import { isApproverValid } from './Validator';
import InfoTooltip from '../../formFields/InfoTooltip';

const warningIcon = <div className='warning-inline warning-nolabel'><Icon  iconName="Warning"/></div>

class Approver extends React.Component {

    componentDidMount() {
        if(this.props.manager === undefined) {
            this._initialApprover();
        }
        else if (!this.props.approver) {
            this.props.addApprover(this.props.manager);
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.currentUser !== this.props.currentUser) {
            this._initialApprover();
        }
        if(prevProps.manager !== this.props.manager) {
            this.props.addApprover(this.props.manager);
        }
    }

    _initialApprover() {
        const approver = this.props.currentUser ? this.props.currentUser.manager : null;
        
        if(!this.props.approver && approver) {
            this.props.addApprover(approver);
        }
    }

    render() {
        const error = this.props.possibleWarning && isApproverValid() !== true ? isApproverValid() : null;
        const warning = this.props.possibleWarning && isApproverValid() !== true
                        ? warningIcon : null;

        return (
            <div className='wizard-inside-second'>
                <div className="item-Approver">
                    Line Manager
                    <InfoTooltip content='The administrator’s line manager and the person to approve the creation of this site.' />
                </div>
                {warning}
                <PeoplePicker
                    defaultUsers={this.props.approver} 
                    disabled={true} 
                    itemLimit={1}
                    errorMessage={error}
                />
            </div>
        );
    }
}

Approver.propTypes = {
    addApprover: PropTypes.func.isRequired,
    approver: PropTypes.object,
    currentUser: PropTypes.object,
    manager: PropTypes.object,
    owner: PropTypes.object,
}


const mapActionToProp = (dispatch) => ({
    addApprover: (element) => { dispatch(addElement(ADD_APPROVER, element)) }
})

const mapStateToProps  = state => ({
    currentUser: state.user.currentUser,
    owner: state.newSite.Owner,
    approver: state.newSite.Approver,
    manager: state.user.manager,
    possibleWarning : state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(Approver);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step4/Approver.js